import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import poweredbydarkbg from "../assets/images/powered_by_dark_background.png";
import EventLogo from "../components/EventLogo";
import Header from "../components/Header";
import { button, text } from "../constants/tailwind-theme";



const PaymentStatusPage = (props) => {

    const navigate = useNavigate();
    const { state } = useLocation();

    return (
        <div className="h-screen">
            <Header />

            <div className=" flex flex-row justify-center items-center  w-full bg-tertiary-300">

                <div className=" flex flex-col items-center justify-start md:w-6/12 w-full h-fulld bg-secondary-500  py-16 px-8">

                    <EventLogo />

                    <h1 className={twMerge(`${text.heading1} text-white text-center my-4`)}> Payment is successful </h1>

                    <div className="mb-4">
                        <p className={twMerge(`${text.description1} text-tertiary-400 text-center`)}>Your ticket has been sent to your e-mail: </p>
                        <h2 className={twMerge(`${text.heading2} text-white text-center`)}>{state?.email ?? "test@email.com"} </h2>
                    </div>
                    
                    <p className={twMerge(`${text.description1} text-tertiary-400 text-center mb-16`)}>For verification purposes, please present your ticket on the day of the event for scanning. Thank you </p>

                    <button className={twMerge(`${button.default} w-full mb-16`)} onClick={() => { navigate("/") }} >
                        <p className={twMerge(`${button.text} text-white text-center`)}>Go back to tickets page</p>
                    </button>

                    <img src={poweredbydarkbg} className="h-6" alt="" />



                </div>

            </div>
        </div>
    );
};

export default PaymentStatusPage;
